import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { API_FILE_REQUEST, API_REQUEST } from '../../constants/api';
import { createReferenceEqualSelector } from '../../selectors/utils';
import type { RootState } from '../..';

interface OngoingRequestState {
  [requestId: string]: string;
}

const initialState: OngoingRequestState = {};

const ongoingrequestsSlice = createSlice({
  name: 'ongoingrequests',
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addMatcher(
        (action) =>
          action.type.match(/^api\/request\/(?:delete|get|put|post|file)\/pending$/),
        (
          state,
          action: PayloadAction<
            unknown,
            string,
            { requestId: string; requestType: string }
          >,
        ) => {
          state[action.meta.requestId] = action.meta.requestType;
        },
      )
      .addMatcher(
        (action) =>
          action.type.match(
            /^api\/request\/(?:delete|get|put|post|file)\/(?:fulfilled|rejected)$/,
          ),
        (state, action: PayloadAction<unknown, string, { requestId: string }>) => {
          delete state[action.meta.requestId];
        },
      ),
});

export default ongoingrequestsSlice.reducer;

const onGoingSelector = (state: RootState) => state.ongoingrequests;

export const selectHasOngoingApiRequest = createReferenceEqualSelector(
  onGoingSelector,
  (state) => Object.values(state).filter((type) => type === API_REQUEST).length > 0,
);
export const selectHasOngoingExports = createReferenceEqualSelector(
  onGoingSelector,
  (state) =>
    Object.values(state).filter((type) => type === API_FILE_REQUEST).length > 0,
);
